import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Content from "../../Dashboard/Content/Content";
import Formikform from "../Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../Utils/Common_Messages";
import { fDate, fDateTime } from "../../../Utils/Date_formet";
import { User_Profile } from "../../../ReduxStore/Slice/Common/commoSlice.jsx";
import { Reset_Password } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import toast from "react-hot-toast";
import ToastButton from "../Alert_Toast";
import Modify_update from "./Modify_update";
import { Modal, Button, Table } from "react-bootstrap";
import { USER_FUND_GETALL_API } from "../../../ReduxStore/Slice/Users/DashboardSlice";
import { UpdateUserProfile } from "../../../Service/Comman/comman";

const avatars = [
  "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  "https://cdn-icons-png.flaticon.com/512/219/219969.png",
  "https://cdn-icons-png.flaticon.com/512/236/236831.png",
  "https://cdn-icons-png.flaticon.com/512/194/194938.png",
  "https://cdn-icons-png.flaticon.com/512/4140/4140037.png",
  "https://cdn-icons-png.flaticon.com/512/4140/4140048.png",
  "https://cdn-icons-png.flaticon.com/512/4140/4140061.png",
  "https://cdn-icons-png.flaticon.com/512/4140/4140051.png",
  "https://cdn-icons-png.flaticon.com/512/4140/4140040.png",
];
const UserProfile = () => {
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const user_role = JSON.parse(localStorage.getItem("user_role"));
  const user_role_goTo = JSON.parse(localStorage.getItem("user_role_goTo"));
  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const token = localStorage.getItem("token");

  const [UserDetails, setUserDetails] = useState([]);
  const [selectedOption, setSelectedOption] = useState("stock");
  const [errorMessage, setErrorMessage] = useState("");
  const [show, setShow] = useState(false);
  const [pricePermission, setPricePermission] = useState("0");
  const [UserLogs, setUserLogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showLogsData, setShowLogsData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [avatar, setAvatar] = useState("../assets/avatar.jgp");
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [showAvatarModal, setShowAvatarModal] = useState(false);


  const handleAvatarClick = (avatar) => {
    setSelectedAvatar(avatar);
  };
  useEffect(() => {
    const savedAvatar = localStorage.getItem("selectedAvatar") || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
    if (savedAvatar) {
      setAvatar(savedAvatar);
    }
  }, []);

  const handleSave = async () => {
    if (selectedAvatar) {
      const res = await UpdateUserProfile(
        {
          id: user_details.user_id,
          img: selectedAvatar,
        },
        token
      );

      if (res.status) {
        localStorage.setItem("selectedAvatar", selectedAvatar);
        toast.success(res.msg);
        // window.location.reload();
        setSelectedAvatar(false);
        setShowAvatarModal(false);
        setSelectedAvatar(false);
        setAvatar(selectedAvatar);

      }
    } else {
    }
  };

  useEffect(() => {
    data();
  }, []);

  const data = async () => {
    const userId = isgotodashboard
      ? gotodashboard.user_id
      : user_details.user_id;
    const token = isgotodashboard ? gotodashboard.token : user_details.token;

    await dispatch(
      User_Profile({
        id: userId,
        token: token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          const data =
            Array.isArray(response.data) && response.data.length
              ? response.data[0]
              : response.data;

          // Map backend -> frontend keys you use in JSX
          const formattedData = {
            _id: data._id,
            FullName: data.FullName,
            Email: data.Email,
            PhoneNo: data.PhoneNo,
            client_key: data.client_key,
            StartDate: data.StartDate,
            EndDate: data.EndDate,
            license_type: data.license_type,
            fund_type: "",
            fund_value: "",
            Role: data.Role,
          };

          setUserDetails(formattedData);

          if (formattedData.fund_type) {
            setSelectedOption(formattedData.fund_type);
          }
        } else {
          setUserDetails({});
        }
      })
      .catch(() => setUserDetails({}));

    await dispatch(USER_FUND_GETALL_API({ user_id: userId, token: token }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setUserLogs(response.data || []);
        } else {
          setUserLogs([]);
        }
      });
  };

  const fields = [
    {
      name: "oldpassword",
      label: "Old Password",
      type: "password",
      label_size: 12,
      col_size: 12,
    },
    {
      name: "newpassword",
      label: "New Password",
      type: "password",
      label_size: 12,
      col_size: 12,
    },
    {
      name: "confirmpassword",
      label: "Confirm Password",
      type: "password",
      label_size: 12,
      col_size: 12,
    },
  ];

  const formik = useFormik({
    initialValues: {
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.oldpassword) {
        errors.oldpassword = valid_err.OLD_PASSWORD_ERROR;
      }
      if (!values.newpassword) {
        errors.newpassword = valid_err.NEW_PASSWORD_ERROR;
      }
      if (!values.confirmpassword) {
        errors.confirmpassword = valid_err.CONFIRM_PASSWORD_ERROR;
      } else if (values.newpassword !== values.confirmpassword) {
        errors.confirmpassword = valid_err.CONFIRM_AND_NEW_PASSWORD_ERROR;
      }

      return errors;
    },
    onSubmit: async (values) => {
      let req = {
        oldpassword: values.oldpassword,
        newpassword: values.newpassword,
        userid: user_details.user_id,
      };
      await dispatch(Reset_Password(req))
        .unwrap()
        .then((response) => {
          if (response.status) {
            toast.success(response.message);
          }
          if (response.response.status === 409) {
            toast.error(response.response.data.message);
          }
        })
        .catch((error) => {
          return;
        });
    },
  });

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setErrorMessage("");
  };

  const maskEmail = (email) => {
    if (!email) return;

    const [name, domain] = email.split("@");

    const { length: len } = name;
    const maskedName = name[0] + "****" + name[len - 1];
    const maskedEmail = maskedName + "@" + domain;
    return maskedEmail;
  };

  return (
    <>
      <Content Page_title="Profile" button_status={false}>
        {UserDetails && (
          <div className="row">
            <div className="col-xl-4">
              <div className="row">
                <div className="col-12">
                  <div className="card form-card">
                    <div className="card-body p-5">
                      <div className="profile-blog">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "200px" }}
                        >
                          <img
                            src={avatar}
                            className="profile-img"
                            alt="Profile Photo"
                            style={{
                              width: "250px",
                              height: "250px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        <div className="container mt-5 text-center">
                          <div className="d-flex justify-content-center gap-2 mt-3">
                            {/* <button className="btn btn-outline-primary rounded px-4">Edit</button> */}

                            {/* Change Button that triggers the Modal */}
                            <button
                              className="btn btn-outline-primary rounded px-2"
                              onClick={() => setShowAvatarModal(true)}
                            >
                              Change
                            </button>
                          </div>

                          {/* Modal Component */}

                          <Modal
                            show={showAvatarModal}
                            onHide={() => setShowAvatarModal(false)}
                            size="lg"
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Select Avatar</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 g-4">
                                {avatars.map((src, idx) => (
                                  <div className="col text-center" key={idx}>
                                    <img
                                      src={src}
                                      alt={`Avatar ${idx + 1}`}
                                      onClick={() => handleAvatarClick(src)}
                                      className={`img-thumbnail rounded-circle ${selectedAvatar === src ? "border border-primary border-3" : ""
                                        }`}
                                      style={{
                                        width: "80px",
                                        height: "80px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => setShowAvatarModal(false)}>
                                Close
                              </Button>
                              <Button variant="primary" onClick={handleSave}>
                                Save Selection
                              </Button>
                            </Modal.Footer>
                          </Modal>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="card form-card p-3">
                <div className="card-body">
                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <ul className="nav nav-tabs w-100">
                        <li className="nav-item">
                          <a
                            data-bs-toggle="tab"
                            href="#about-me"
                            className="nav-link text-center active"
                          >
                            About Me
                          </a>
                        </li>


                       {/* {user_role === "USER" ||
                          user_role === "ADMIN" ||
                          !gotodashboard &&  */}
                          <li className="nav-item">
                          <a
                            data-bs-toggle="tab"
                            href="#profile-settings"
                            className="nav-link text-center"
                          >
                            Change Password
                          </a>
                        </li>
                        {/* } */}


                        {UserDetails.license_type == "2" &&
                          UserDetails.broker == "19" && (
                            <li className="nav-item">
                              <a
                                href="#fund-management"
                                data-bs-toggle="tab"
                                className="nav-link text-center"
                              >
                                Stock Fund
                              </a>
                            </li>
                          )}
                      </ul>

                      <div className="tab-content">
                        <div
                          id="about-me"
                          className="tab-pane fade active show"
                        >
                          <div className="profile-personal-info pt-3">
                            <h4 className=" mb-4">Personal Information</h4>
                            <div className="row mb-2">
                              <div className="col-sm-3 col-5">
                                <h6 className="f-w-500">
                                  Name <span className="pull-end">:</span>
                                </h6>
                              </div>
                              <div className="col-sm-9 col-7">
                                <span>
                                  {UserDetails && UserDetails.FullName}
                                </span>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-sm-3 col-5">
                                <h6 className="f-w-500">
                                  Email <span className="pull-end">:</span>
                                </h6>
                              </div>
                              <div className="col-sm-9 col-7">
                                <span>
                                  {user_role == "SUBADMIN"
                                    ? isgotodashboard
                                      ? user_details?.Subadmin_permision?.[0]
                                        ?.detailsinfo
                                        ? UserDetails?.Email
                                        : UserDetails?.Email
                                      : maskEmail(UserDetails?.Email)
                                    : UserDetails?.Email}
                                </span>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-sm-3 col-5">
                                <h6 className="f-w-500">
                                  Contact <span className="pull-end">:</span>
                                </h6>
                              </div>
                              <div className="col-sm-9 col-7">
                                <span>
                                  {UserDetails?.PhoneNo &&
                                    `${"*".repeat(
                                      UserDetails.PhoneNo.length - 4
                                    )}${UserDetails.PhoneNo.slice(-4)}`}
                                </span>
                              </div>
                            </div>

                            <div className="row mb-2">
                              <div className="col-sm-3 col-6">
                                <h6 className="f-w-500">
                                  CLIENT_KEY <span className="pull-end">:</span>
                                </h6>
                              </div>
                              <div className="col-sm-9 col-6">
                                <span>{UserDetails?.client_key || "-"}</span>
                              </div>
                            </div>

                            {user_role === "USER" ||
                              (isgotodashboard == true &&
                                gotodashboard.Role == "USER") ? (
                              <>
                                <div className="row mb-2">
                                  <div className="col-sm-3 col-5">
                                    <h6 className="f-w-500">
                                      Start-Date
                                      <span className="pull-end">:</span>
                                    </h6>
                                  </div>
                                  <div className="col-sm-9 col-7">
                                    <span>
                                      {UserDetails.StartDate &&
                                        fDate(UserDetails.StartDate)}
                                    </span>
                                  </div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-sm-3 col-5">
                                    <h6 className="f-w-500">
                                      End Date{" "}
                                      <span className="pull-end">:</span>
                                    </h6>
                                  </div>
                                  <div className="col-sm-9 col-7">
                                    <span>
                                      {UserDetails?.EndDate &&
                                        fDate(UserDetails?.EndDate)}
                                    </span>
                                  </div>
                                </div>

                                <div className="row mb-2">
                                  <div className="col-sm-3 col-5">
                                    <h6 className="f-w-500">
                                      Client Type
                                      <span className="pull-end">:</span>
                                    </h6>
                                  </div>
                                  <div className="col-sm-9 col-7">
                                    <span>
                                      {UserDetails &&
                                        UserDetails.license_type == "2"
                                        ? "Live"
                                        : UserDetails &&
                                          UserDetails.license_type == "1"
                                          ? "Free Demo"
                                          : "Free 2 Days"}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div id="modify" className="tab-pane fade mt-3">
                          <h4 className=" mb-4">Modify Updates</h4>
                          <Modify_update
                            UserDetails={UserDetails && UserDetails}
                          />
                        </div>

                        {user_role === "USER" ||
                          user_role === "ADMIN" ||
                          !gotodashboard ? (
                          <>
                            <div id="profile-settings" className="tab-pane fade">
                              <h4 className=" mb-4 mt-3">Change Password</h4>
                              {gotodashboard ? (
                                ""
                              ) : (
                                <Formikform
                                  fieldtype={fields.filter(
                                    (field) =>
                                      !field.showWhen ||
                                      field.showWhen(formik.values)
                                  )}
                                  formik={formik}
                                  btn_name="Update"
                                  title="forlogin"
                                />
                              )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        <div id="permission" className="tab-pane fade mt-3">
                          <div className="profile-personal-info pt-3">
                            <h4 className=" mb-4">
                              Permission Update
                              {/* ADD I BUUTON */}
                              <i
                                className="bi bi-info-circle"
                                style={{ marginLeft: "5px" }}
                                onClick={(e) => setShowModal(true)}
                              ></i>
                            </h4>

                            <div className="row mb-2">
                              <div className="col-sm-9 col-7">
                                {/* Radio Buttons */}
                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id="mt4Option"
                                    name="Mt 4"
                                    value="0"
                                    checked={pricePermission == "0"}
                                    onChange={(e) =>
                                      setPricePermission(e.target.value)
                                    }
                                    disabled={isgotodashboard}
                                  />
                                  <label
                                    className="ms-1 form-check-label"
                                    htmlFor="mt4Option"
                                  >
                                    MT 4
                                  </label>
                                </div>

                                <div className="form-check form-check-inline">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    id="livePriceOption"
                                    name="liveprice"
                                    value="1"
                                    checked={pricePermission == "1"}
                                    onChange={(e) =>
                                      setPricePermission(e.target.value)
                                    }
                                    disabled={isgotodashboard}
                                  />
                                  <label
                                    className="ms-1 form-check-label"
                                    htmlFor="livePriceOption"
                                  >
                                    Live Price
                                  </label>
                                </div>

                                {/* Error Message */}
                                {errorMessage && (
                                  <div className="text-danger mt-2">
                                    {errorMessage}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="fund-management" className="tab-pane fade">
                          <div className="profile-personal-info pt-3">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                              <h4 className="">Fund Management</h4>
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                onClick={handleShowModal}
                              >
                                <i
                                  className="bi bi-info-circle"
                                  style={{
                                    fontSize: "1.5rem",
                                    color: "#0d6efd",
                                  }}
                                ></i>
                              </button>
                            </div>

                            <div className="row mb-2">
                              <div className="row align-items-center">
                                <div className="col-sm-9 col-7">
                                  {/* Radio Buttons */}
                                  <div className="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="stockWise"
                                      name="option"
                                      value="stock"
                                      checked={selectedOption === "stock"}
                                      onChange={handleOptionChange}
                                      disabled={isgotodashboard}
                                    />
                                    <label
                                      className="ms-1 form-check-label"
                                      htmlFor="stockWise"
                                    >
                                      Stock Wise
                                    </label>
                                  </div>

                                  <div className="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="fundWise"
                                      name="option"
                                      value="fund"
                                      checked={selectedOption === "fund"}
                                      onChange={handleOptionChange}
                                      disabled={isgotodashboard}
                                    />
                                    <label
                                      className="ms-1 form-check-label"
                                      htmlFor="fundWise"
                                    >
                                      Fund Wise
                                    </label>
                                  </div>

                                  <div className="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="percentageWise"
                                      name="option"
                                      value="percentage"
                                      checked={selectedOption === "percentage"}
                                      onChange={handleOptionChange}
                                      disabled={isgotodashboard}
                                    />
                                    <label
                                      className="ms-1 form-check-label"
                                      htmlFor="percentageWise"
                                    >
                                      Percentage Wise
                                    </label>
                                  </div>

                                  {/* Error Message */}
                                  {errorMessage && (
                                    <div className="text-danger mt-2">
                                      {errorMessage}
                                    </div>
                                  )}

                                  {/* Submit Button */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ToastButton />
            </div>
          </div>
        )}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Fund Management History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* History Table */}
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Fund Status</th>
                  <th>Fund Amount</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {UserLogs && UserLogs.length > 0 ? (
                  UserLogs.map((record, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{record.fund_status || "-"}</td>
                      <td>{record.fund_amount || "-"}</td>
                      <td>
                        {record.createdAt ? fDate(record.createdAt) : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {showModal && (
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Price Permission Logs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {showLogsData && showLogsData.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th>ID</th>
                        <th>Status</th>
                        <th>Message</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {showLogsData.map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1 || "N/A"}</td>
                          <td>{data.status === 1 ? "On" : "Off"}</td>
                          <td>{data.msg || "No Message"}</td>
                          <td>{fDateTime(data.createdAt)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No logs available.</p>
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Content>
    </>
  );
};

export default UserProfile;
